module.exports = __webpack_public_path__ + "5561b68c39da7036f12c563a99f5003a.pdf";